// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4b230b78","239":"be6717b2","455":"1de7423f"}[chunkId] + ".chunk.js";
};